import AcceptedShiftsScreen from "@/app/(app)/(crew)/home/accepted";

export default AcceptedShiftsScreen;
